/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Question/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Actions from './Actions/index'
import React from 'react'
import TysiaInputQuestion from 'DesignSystem/TysiaInputQuestion/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Question({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/Content/Categories/Category/Questions/Question"
  
}) {
let questionItemIndexValueData = fromData.useDataFormat({ viewPath,
context: 'question_item',
path: 'index',
format: fromFormat.odd,
})
let questionTypeValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'type',
})
let constantData = 'multichoice'
let aggregateData = fromAggregate.equals(questionTypeValueData, constantData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let categoryDisabledValueData = fromData.useDataValue({ viewPath,
context: 'category',
path: 'disabled',
})
let questionTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'question',
path: 'type',
})
let constantData1 = 'multichoice'
let aggregateData1 = fromAggregate.equals(questionTypeValueData1, constantData1)
let categoryIdValueData = fromData.useDataValue({ viewPath,
context: 'category',
path: 'id',
})
let constantData2 = 'general'
let aggregateData2 = fromAggregate.equals(categoryIdValueData, constantData2)
  return (<React.Fragment
>
<div
  data-testid="Question.Horizontal"
  data-view-path={viewPath}
 style={{'--pr-1-Z1iwBUS': questionItemIndexValueData ? "0px" : aggregateData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--w-2-Z1iwBUS': aggregateData ? "100%" : "50%"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputQuestion
  viewPath={`${viewPath}/TysiaInputQuestion`}
 data={aggregateData1 ? "category.id" : "category.disabled"}
 disabled={categoryDisabledValueData}
 marginTop={dtSpaceS}
 isToggle={aggregateData1 ? true : false}
 showAlert={aggregateData2 ? false : true}
 data={aggregateData1 ? "category.id" : "question.type"}
 data={aggregateData1 ? "category.id" : "'multichoice'"}
 aggregate={aggregateData2 ? "/Data/aggregate.js equals" : "/Data/aggregate.js equals"}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
{children}
</React.Fragment>)
}